
export default function Demerits() {
  const demerits = [
    {
      title: '提携金融機関口座が必須',
      description: 'このカードは提携金融機関口座保有者限定のカードです。口座をお持ちでない方は、まず口座開設が必要になります。',
      solution: '提携金融機関のアプリで来店不要・郵送不要で口座開設できます。'
    },
    {
      title: '基本還元率は0.5%と標準的',
      description: '通常のポイント還元率は1,000円で1ポイント（0.5%）と、高還元率カードと比べると控えめです。',
      solution: '提携店舗での+2%還元や、直売所5%割引など、特定の場所での特典が充実しています。'
    },
    {
      title: '2年目以降は年会費がかかる場合あり',
      description: '初年度は無料ですが、2年目以降は1,375円（税込）の年会費がかかります。',
      solution: '年間12万円以上の利用、または電気・携帯料金の支払い登録で翌年も無料になります。'
    },
    {
      title: 'ゴールドカードは年会費無料条件なし',
      description: 'ゴールドカードは年会費無料化サービスの対象外です。',
      solution: '一般カードであれば条件達成で年会費無料を維持できます。'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-[#003366] mb-4 text-center">
          地域密着型クレジットカードのデメリット・注意点
        </h2>
        <p className="text-gray-600 text-center mb-12">
          申込み前に知っておきたいポイント
        </p>

        <div className="space-y-6">
          {demerits.map((demerit, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-6 border-l-4 border-[#FF9900]">
              <div className="flex items-start gap-4">
                <div className="w-8 h-8 bg-[#FF9900] text-white rounded-full flex items-center justify-center flex-shrink-0 font-bold text-sm">
                  {index + 1}
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-bold text-[#003366] mb-2">{demerit.title}</h3>
                  <p className="text-gray-600 text-sm mb-3">{demerit.description}</p>
                  <div className="bg-[#F0FFF4] rounded-lg p-3">
                    <p className="text-sm text-[#00A040]">
                      <i className="ri-lightbulb-line mr-1 w-4 h-4 inline-flex items-center justify-center"></i>
                      <span className="font-medium">解決策：</span>{demerit.solution}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
